import { SquareCheck } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CheckSquareIcon = createLucideIcon(SquareCheck);
